
import { Component, Prop, Vue } from 'vue-property-decorator'
import LabelBase from '@/components/atoms/LabelBase.vue'

/**
 * 択一式の回答入力部
 */
@Component({
  components: {
    LabelBase,
  },
})
export default class SingleChoices extends Vue {
  /** 表示値 */
  @Prop()
  private options!: string[]

  /** 初期値 */
  @Prop()
  private defaultValue!: string

  /** 選択値 */
  public selectedValue = ''

  /**
   * 初期処理
   */
  private mounted(): void {
    this.selectedValue = this.defaultValue
  }

  /**
   * 該当項目が選択中かを判定する
   *
   * @param value 該当項目の値
   * @returns 選択中か否か
   */
  private isSelected(value: string): boolean {
    return value === this.selectedValue
  }
}
